export default __webpack_public_path__ + "static/media/MA.d3406e75.svg";